import { spacePost } from "./space";

/** Настройки виджета партнёра, приходят с /widget/get */
export interface WidgetData {
    /** Код партнёра, например "technodom" */
    code: string;
    data: {
        /** Например "article_first" */
        topup_type: string;
        /** Флаги приходят строками "0" | "1" */
        imei_required: string;
        topup_enabled: string;
        measurement_id: string;
        api_secret: string;
        chat: string;
        min_order: string;
        font_family: string;
        font_link: string;
        font_size: string;
        main_color: string;
        text_color: string;
        pickup_only: string;
        get_discount_later?: string;
    };
    token: string;
    /** Доступные локали, например ["ru", "en", "kz"] */
    locales: string[];
    /** Страна партнёра, например "kz" */
    location: string;
    widget_id: number;
}

interface GetWidgetDataResponse {
    status: number;
    data: WidgetData;
}

/** Получить данные виджета партнёра (токен, локали, стили и т.д.) */
export async function apiGetWidgetData(payload: { domain: string }): Promise<WidgetData> {
    const response = await spacePost<GetWidgetDataResponse>("/widget/get", payload);
    return response.data;
}
